import { useEffect, useState } from "react"
import WithoutSidebar from "../../layouts/WithOutSidebar"
import { useSnackbar } from 'notistack'
import Input from "../../blocks/Input"
import { ajax } from "../../scripts/helper"
import utils from "../../scripts/utils"
import { useNavigate } from "react-router-dom"

import './login.css'
import { useForm } from "../../hooks/useForm"
import context from '../../scripts/context'

const Login = () => {
    const { enqueueSnackbar } = useSnackbar()
    const navigate = useNavigate()
    const [inputFields, handleChange, setInputFields] = useForm({
        username: {
            name: 'username',
            value: '',
            type: 'text',
            placeholder: 'sales',
            require: true
        },
        password: {
            name: 'password',
            value: '',
            type: 'password',
            placeholder: '******',
            require: true
        }
    })

    const login = async () => {

        console.log(inputFields.username.value)
        const res = await ajax({
            method: 'POST',
            url: utils.urls.login,
            snackbar: enqueueSnackbar,
            data: {
                username: inputFields.username.value,
                password: inputFields.password.value
            }
        })
        console.log(res, 'resssss')

        if (!res) return

        console.log(res)


        window.localStorage.setItem('token', res.data.token)
        window.localStorage.setItem('office', res.data.office)
        window.localStorage.setItem('name', res.data.name)
        window.localStorage.setItem('privileges', res.data.privileges)
        window.localStorage.setItem('expiration', res.data.expiration)
        window.localStorage.setItem('refreshToken', res.data.refreshToken)


        const response = await ajax({
            method: 'GET',
            url: utils.urls.userInformation,
            token: res.data.token,
            snackbar: enqueueSnackbar
        })

        if(!response) return

        console.log(response.data, 'response ee user info')

        window.localStorage.setItem('userInfo', JSON.stringify(response.data))

        context.setIsLoggedIn(true)

        
        navigate('/agent/payments', {replace: true})
    }
    useEffect( () => {
        if(context.getIsLoggedIn() ) navigate('/agent/payments', {replace:true})
    }, [])

    const checkEnter = (event) => {
        if(event.keyCode === 13){
            login()
        }
    }

    return (
        <WithoutSidebar isLogin={true}>
            <div className="login-container">
                <div className="login-container__background">
                    {/* <img src="/images/airplane.png" /> */}
                </div>
                <div className="container">
                    <div className="login-box">
                        <div className="login-box__header">Login</div>
                        <div className="username">
                            <label>Username*</label>
                            <div className="username-input">
                                <Input inputField={inputFields.username} onChange={handleChange} />
                            </div>
                        </div>
                        <div className="password">
                            <label>Password*</label>
                            <div className="password-input">
                                <Input inputField={inputFields.password} onChange={handleChange} onKeyDown={e => checkEnter(e)}/>
                            </div>
                        </div>
                        {/* <div className="login-box__reset">
                            <p className="p1">Forget Password?</p> <a href="#" className="p2">Reset</a>
                        </div> */}

                        <button className="login-box__btn" onClick={login} >Login</button>

                    </div>
                </div>
            </div>
        </WithoutSidebar>
    )

}
export default Login